import React, {useEffect, useRef, useState} from "react";
import {InfiosKeyFacts} from "./KeyFacts.style";
import KeyFactsItem from "./KeyFactsItem/KeyFactsItem";
import {useIsMobile} from "../../utils/styled/_mixins.style";
import {ErrorBoundary} from "react-error-boundary";
import {urlHasParam} from "../../utils/js/params";

const KeyFacts = (props) => {
    const { title, subTitle, keyFactList, id, background } = props;

    const { isMobile } = useIsMobile();

    const [limiterDisplay, setLimiterDisplay] = useState(false);
		const [titleSize, setTitleSize] = useState(80);

    useEffect(() => {
        keyFactList?.length % 2 !== 0 ? setLimiterDisplay(true) : setLimiterDisplay(false);
    }, [keyFactList]);

    useEffect(() => {
        function handleResize() {
            if (isMobile) {
                setLimiterDisplay(false);
            } else {
                keyFactList?.length % 2 !== 0 ? setLimiterDisplay(true) : setLimiterDisplay(false);
            }
        }

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [isMobile, keyFactList?.length]);

    const unsetGrid = useRef(null);

    useEffect(() => {
        unsetGrid.current?.parentElement.classList.add(`unset__grid`);
        },[]);

    return (
        <InfiosKeyFacts ref={unsetGrid} id={id} hasSubtitle={!!subTitle} background={background}>
            {subTitle && <p className="key-facts-subtitle">{subTitle}</p>}
            {title && <h2 className="heading-2">{title}</h2>}
            <div className="key-facts-wrapper">
                {keyFactList && keyFactList?.map((keyFact, index) => {
                   return <KeyFactsItem {...keyFact} key={`${id}-key-fact-${index}`} titleSize={titleSize} setTitleSize={setTitleSize} />
                })}
                {limiterDisplay && <div className="limiter"></div>}
            </div>
        </InfiosKeyFacts>
    )
}

const KeyFactsHandleErrors = props => {
    return (
        <ErrorBoundary fallback={props.isInEditor || urlHasParam('wcmmode=disabled') ? <div style={{minHeight: '50px', display: 'flex', alignItems: 'center', backgroundColor: '#ffe1db'}}><p>The keyfacts component is currently experiencing errors. Please try again later.</p></div> : <div></div>}>
            <KeyFacts {...props}/>
        </ErrorBoundary>
    )
  }


export default KeyFactsHandleErrors;
